export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Запрос в техническую поддержку"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["от"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить сообщение"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Файлы"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы можете загрузить один или несколько файлов. Максимальный размер файла - 10Мб."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Текст сообщения"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправить"])}
}